import { useEffect, useState } from "react";
import axios from "axios";
import { MessageSquare, Mail, Check, X } from "lucide-react";
import { ProfileTags } from "@/components/smartleads/ProfileTags";
import { JourneyLine } from "@/components/smartleads/JourneyLine";

const API = `${process.env.REACT_APP_BACKEND_URL}/api/smart-leads`;
const Ch = ({ ok, label, Icon, tid, title }) => (
  <span title={title} data-testid={tid} className={`inline-flex items-center gap-1 rounded-full border px-2 py-0.5 text-[11px] font-semibold ${ok ? "bg-emerald-50 text-emerald-700 border-emerald-200" : "bg-slate-50 text-slate-400 border-slate-200"}`}>
    <Icon className="w-3 h-3" />{label}{ok ? <Check className="w-3 h-3" /> : <X className="w-3 h-3" />}
  </span>
);

// Lead detail: what we know about the lead (dog, breed, service, dates, concerns, best time) + which channels are OK.
export const LeadProfileStrip = ({ leadId }) => {
  const [d, setD] = useState(null);
  useEffect(() => {
    axios.post(`${API}/profile-tags`, { lead_ids: [leadId], generate: true }).then((r) => setD(r.data)).catch(() => setD({}));
  }, [leadId]);
  const tags = d?.tags?.[leadId];
  if (!d || (!tags?.length && !d.channels)) return null;
  const c = d.channels || {};
  return (
    <div className="flex flex-wrap items-center gap-1.5" data-testid="lead-profile-strip">
      <ProfileTags tags={tags} />
      {d.channels && <>
        <Ch ok={c.sms_ok} label="Text (SMS)" Icon={MessageSquare} title={c.sms_why} tid="lead-channel-sms" />
        <Ch ok={c.email_ok} label={c.prefers_email ? "Email · preferred" : "Email"} Icon={Mail} tid="lead-channel-email" />
      </>}
      <JourneyLine j={d.journey} tid="lead-detail-journey" />
    </div>
  );
};
